import { useShallow } from 'zustand/react/shallow';
import useWidth from '../../../../components/Hooks/useWidth';
import storage from '../../../../hooks/useStorage/useStorage';
import { IProductDetailsGridParams } from '../../../../services/modules/productDetails/productDetails.types';
import useOrderBookStore from '../../../../stores/OrderBook/orderBook.store';
import useProductDetailsStore from '../../../../stores/ProductDetails/productDetails.store';
import useOrderBook from '../../../order-book/hooks/useOrderBook';
import { resolveProductDetailsOrderIds } from './useOpenProductDetails.utils';

export interface OpenProductDetailsParams {
  productId?: string;
  productColorId?: string;
  kitId?: string;
}

const useOpenProductDetails = () => {
  const { mobileWidth } = useWidth();
  const selectedOrder = useOrderBookStore((state) => state.selectedOrder);
  const { allOrders } = useOrderBook();
  const { productGridParams, setProductDetailsModalState, handleOpenProductDetailsModal } =
    useProductDetailsStore(
      useShallow((state) => ({
        productGridParams: state.productGridParams,
        setProductDetailsModalState: state.setProductDetailsModalState,
        handleOpenProductDetailsModal: state.handleOpenProductDetailsModal,
      })),
    );

  const openProductDetails = ({ productId, productColorId, kitId }: OpenProductDetailsParams) => {
    const filterPreferences = storage.getProductDetailsFilter(storage.getSessionId() as string);
    const orderIds = resolveProductDetailsOrderIds({
      shouldApplyAllOrders: filterPreferences?.applyAllOrders && !mobileWidth,
      allOrders,
      selectedOrderId: selectedOrder?.id,
    });

    if (kitId) {
      setProductDetailsModalState({ isOpen: true, kitId });
      handleOpenProductDetailsModal(
        { ...productGridParams, orderIds, isFinishedOrder: false, availability: undefined },
        filterPreferences?.applyRelatedProducts,
      );
      return;
    }

    setProductDetailsModalState({ isOpen: true, productId, productColorId });

    const gridParams: IProductDetailsGridParams = {
      ...productGridParams,
      productColorId: filterPreferences?.applyAllColors ? undefined : productColorId,
      availability: filterPreferences?.availabilityFilter,
      isFinishedOrder: false,
      orderIds,
    };

    handleOpenProductDetailsModal(gridParams, filterPreferences?.applyRelatedProducts);
  };

  return { openProductDetails };
};

export default useOpenProductDetails;
